import React from "react";
import Checkbox from "../../../../../components/Checkbox";

interface BooleanFiltersProps {
  booleanFilters: string[];
  setBooleanFilters: (next: string[]) => void;
}

export const BooleanFilters = ({
  booleanFilters,
  setBooleanFilters,
}: BooleanFiltersProps) => {
  const walkthroughPermissionOptions: string[] = [
    "Regular Service Requests",
    "Internal",
    "Homeowner or Occupant",
    "Grouped",
    "Imported",
  ];

  return (
    <>
      {walkthroughPermissionOptions.map((permission: string, index: number) => (
        <Checkbox
          label={permission}
          size="small"
          key={`walkthrough-permission-checkbox-${index}`}
          value={booleanFilters.includes(permission)}
          onChange={() => {
            if (booleanFilters.includes(permission)) {
              setBooleanFilters(
                booleanFilters.filter((item: string) => item !== permission)
              );
            } else {
              setBooleanFilters([...booleanFilters, permission]);
            }
          }}
        />
      ))}
    </>
  );
};
